// Os yn neud newid i hwn, mae angen newid bob distaw-ailgyfeirio.*.html hefyd.
import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';
import { environment } from '../../../environments/environment';

export const config: UserManagerSettings = {
    authority: environment.hunaniaethCyfeiriad,
    client_id: environment.hunaniaethIdCleient,
    redirect_uri: `${environment.gwreiddynCleient}dilysu-ailgyfeirio`,
    post_logout_redirect_uri: `${environment.gwreiddynCleient}allgofnodi-ailgyfeirio`,
    response_type: environment.hunaniaethResponseType,
    scope: environment.hunaniaethScope,
    automaticSilentRenew: true,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    silent_redirect_uri: `${environment.gwreiddynCleient}assets/distaw-ailgyfeirio.html`
};